import React, { useEffect, useRef } from 'react';

const NativeBanner = ({ title = 'Recommended For You' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Clear old ad
    container.innerHTML = '';

    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '250px';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';

    container.appendChild(iframe);

    // Write ad inside iframe
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8" />
          <style>
            body {
              margin: 0;
              padding: 0;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div id="container-887936ae49ee5d2c8cff6428012c2c24"></div>

          <script type="text/javascript">
            var atOptions = {
              key: '887936ae49ee5d2c8cff6428012c2c24',
              format: 'native',
              params: {}
            };
          </script>

          <script
            async
            data-cfasync="false"
            src="https://pl31658004.profitableratecpmnetwork.com/887936ae49ee5d2c8cff6428012c2c24/invoke.js">
          </script>
        </body>
      </html>
    `);
    doc.close();
  }, []);

  return (
    <div style={{ margin: '20px 0', textAlign: 'center' }}>
      <h3 style={{ fontSize: '1rem', color: '#666', marginBottom: '10px' }}>
        {title}
      </h3>

      <div
        ref={containerRef}
        style={{ minHeight: '250px', width: '100%' }}
      />
    </div>
  );
};

export default NativeBanner;